<template>
<div>
    <div class="md-layout rows-relatorio">
        <div v-if="permissoes.empresasCoveniadasRead || permissoes.pagamentosFornecedorDiaRead || permissoes.pagamentosFornecedorRead || 
        permissoes.pagamentosFornecedorCanceladoRead || permissoes.usuarioVendedorRead || permissoes.repasseFornecedorRead" class="md-layout-item md-size-100 md-xsmall-size-100">
            <strong class="text-relatorio text-site">FORNECEDOR</strong>
        </div>
        
        <div v-if="permissoes.usuarioVendedorRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'usuarioVendedorRead'}">
                <i class="fas fa-users icon-relatorio text-info"></i>
                <strong class="text-relatorio">VENDEDORES</strong>
            </router-link>
        </div>

        <div v-if="permissoes.empresasCoveniadasRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'empresasCoveniadasRead'}">
                <i class="fas fa-building icon-relatorio text-info"></i>
                <strong class="text-relatorio">EMPRESAS CONVENIADAS</strong>
            </router-link>
        </div>

        <div v-if="permissoes.pagamentosFornecedorRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'pagamentosFornecedorRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">PAGAMENTOS DE FORNECEDORES</strong>
            </router-link>
        </div>

        <div v-if="permissoes.pagamentosFornecedorCanceladoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'pagamentosFornecedorCanceladoRead'}">
                <i class="fas fa-credit-card icon-relatorio text-danger"></i>
                <strong class="text-relatorio">PAGAMENTOS CANCELADOS DE FORNECEDORES</strong>
            </router-link>
        </div>

        <div v-if="permissoes.repasseFornecedorRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'repasseFornecedorRead'}">
                <i class="fas fa-hand-holding-usd icon-relatorio text-info"></i>
                <strong class="text-relatorio">RECEBÍVEIS ANALÍTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.repasseFornecedorSinteticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'repasseFornecedorSinteticoRead'}">
                <i class="fas fa-hand-holding-usd icon-relatorio text-info"></i>
                <strong class="text-relatorio">RECEBÍVEIS SINTÉTICO</strong>
            </router-link>
        </div>
        
        <div v-if="permissoes.pagamentosFornecedorDiaRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'pagamentosFornecedorDiaRead'}">
                <i class="fas fa-credit-card icon-relatorio text-info"></i>
                <strong class="text-relatorio">PAGAMENTOS DO DIA</strong>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
};
</script>
